/**
 * Customer Perception Insights Page
 * Main page component that renders the Customer Perception dashboard
 */

import React from "react";
import { CustomerPerceptionContainer } from "../components/CustomerPerception/CustomerPerceptionContainer";

const CustomerPerceptionPage: React.FC = () => {
    return (
        <div style={{ minHeight: "100vh" }}>
            <CustomerPerceptionContainer />
        </div>
    );
};

export default CustomerPerceptionPage;
